import { toast, ToastOptions } from "react-toastify";

const baseToastStyle: ToastOptions = {
  style: {
    minHeight: "36px",
    padding: "10px",
    display: "flex",
    alignItems: "center",
  },
};

export const showSuccessToast = (message: string) =>
  toast.success(message, {
    ...baseToastStyle,
    style: {
      ...baseToastStyle.style,
      backgroundColor: "#16A34A",
    },
  });

export const showErrorToast = (message: string) =>
  toast.error(message, baseToastStyle);

export const showInfoToast = (message: string) =>
  toast.info(message, baseToastStyle);

export const showWarningToast = (message: string) =>
  toast.warning(message, baseToastStyle);

export const showToast = (message: string) => toast(message, baseToastStyle);
